import React, { useState } from 'react';
import { makeStyles, createStyles, Theme, Typography, MenuItem, Button } from '@material-ui/core';
import { Formik, Form } from 'formik';
import Schema from '../../schema';
import { useTranslation } from 'react-i18next';
import SelectPicker from '../../components/selectPicker/index';
import { useDispatch, useSelector } from 'react-redux';
import { ReducersModel } from '../../model';
import { editOperation } from './action';
import { useHistory } from 'react-router-dom';
import AutoComplete from '../../components/inputs/autoComplete';
import SimpleModal from '../../components/modal';
import { ImageCaurosel } from '../../components/caurosel/imagecaurosel';
import Utils from '../../utils';
import { minuteToTime } from '../../utils/convertTime';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            '& .MuiTextField-root': {
                marginBottom: '10px!important',
            },
        },
        textStyl: {
            fontSize: '20px',
            color: 'var(--dark-grey)',
            margin: '19px 0 0 0',
        },
        paper: {
            position: 'absolute',
            width: '25%',
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
        saveContainer: {
            backgroundColor: 'white',
            padding: '10px 0',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '13px',
        },
        cancelButton: {
            margin: '0 15px',
            minWidth: '100px',
            textAlign: 'center',
            font: 'normal normal medium 16px/20px Roboto',
            letterSpacing: '0.06px',
            color: '#515151',
            opacity: 1,
            height: '36px',
        },
        saveButton: {
            margin: '0 15px',
            minWidth: '100px',
            textAlign: 'center',
            font: 'normal normal medium 16px/20px Roboto',
            letterSpacing: '0.06px',
            color: '#FFFFFF',
            opacity: 1,
            height: '36px',
        },
        populateField: {
            marginBottom: '12px',
            '& div': {
                wordBreak: 'break-word',
            },
            '& div:nth-child(1)': {
                font: 'normal normal normal 9px/21px Roboto',
                opacity: 1,
                color: 'rgba(0, 0, 0, 0.54)',
                letterSpacing: '0.07px',
            },
            '& div:nth-child(2)': {
                font: 'normal normal normal 14px/14px Roboto',
                opacity: 1,
                letterSpacing: '0.07px',
                color: 'rgba(0, 0, 0, 0.87)',
                marginTop: '2px',
            },
        },
        populateFieldAttachment: {
            marginBottom: '12px',
            '& div': {
                font: 'normal normal normal 9px/21px Roboto',
                opacity: 1,
                color: 'rgba(0, 0, 0, 0.54)',
                letterSpacing: '0.07px',
            },
        },
        imgContainer: {
            display: 'flex',
        },
        innerImgContainer: {
            marginRight: '20px',
            '& .MuiTypography-body1': {
                font: 'normal normal normal 11px/21px Roboto',
                opacity: 1,
            },
        },
        attachmentImage: {
            height: '64px',
            width: '64px',
            border: '1px solid black',
        },
    }),
);

export default function EditOperation({ handleClose }: any) {
    const classes = styles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [openImage, setOpenImage] = useState(false);
    const [imgToOpen, setImgToOpen] = useState(0);
    const history = useHistory();
    const {
        selectedOperationcode,
        selectedDescription,
        selectedFrequency,
        selectedMachine,
        selectedNeedleType,
        selectedSmv,
        selectedTct,
        selectedMachineName,
        selectedNeedleTypeName,
        selectedOperatorId,
        selectedOperationCodeId,
        selectedOperation,
    } = useSelector((state: ReducersModel) => state.sewingOperationForAddStyleReducer);
    const { machines } = useSelector((state: ReducersModel) => state.machineListReducer);
    const { needlesTypes } = useSelector((state: ReducersModel) => state.needleListReducer);
    const { operationCodeData } = useSelector((state: ReducersModel) => state.operationCodeReducer);
    const {
        machineAttachment1Data,
        machineAttachment2Data,
        machineAttachment3Data,
        machineAttachmentImage1,
        machineAttachmentImage2,
        machineAttachmentImage3,
    } = selectedOperation;

    function getModalStyle() {
        const top = 50;
        const left = 50;

        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }

    const [modalStyle] = React.useState(getModalStyle);

    const handleImageOpen = (idx: number) => {
        setImgToOpen(idx);
        setOpenImage(true);
    };

    const handleImageClose = () => {
        setOpenImage(false);
    };
    const needlesListing = () => {
        return needlesTypes && needlesTypes.length > 0
            ? needlesTypes.map((data: any, index: any) => {
                return (
                    <MenuItem key={index} id={data.season} value={data.id}>
                        {data.needleType}
                    </MenuItem>
                );
            })
            : null;
    };

    const machineSubtypeListing = () => {
        return machines && machines.length > 0
            ? machines.map((data: any, index: any) => {
                return (
                    <MenuItem key={index} value={data.id}>
                        {data.subType}
                    </MenuItem>
                );
            })
            : null;
    };

    return (
        <div style={modalStyle} className={classes.paper}>
            <div className={classes.mainContainer}>
                <Typography className={classes.textStyl}>{t('EditOperation')}</Typography>
                <div>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            operationId: selectedOperatorId,
                            operationCodeId: selectedOperationCodeId,
                            operationcode: selectedOperationcode,
                            description: selectedDescription,
                            frequency: selectedFrequency,
                            machine: selectedMachine,
                            needleType: selectedNeedleType,
                            smv: selectedSmv,
                            tct: selectedTct,
                            machineName: selectedMachineName,
                            needleTypeName: selectedNeedleTypeName,
                            tempOperationCode: selectedOperationcode,
                            operation: selectedOperation,
                            images: [machineAttachmentImage1, machineAttachmentImage2, machineAttachmentImage3],
                            imageCodes: [
                                machineAttachment1Data?.displayName,
                                machineAttachment2Data?.displayName,
                                machineAttachment3Data?.displayName,
                            ],
                        }}
                        validationSchema={Schema.AddOperationSchema(t)}
                        onSubmit={(values, { setSubmitting }) => {
                            const styleId = new URL(window.location.href).searchParams.get('id');
                            if (styleId === null) {
                                dispatch(
                                    editOperation(
                                        values,
                                        setSubmitting,
                                        history,
                                        handleClose,
                                        localStorage.getItem('styleAddedId'),
                                    ),
                                );
                            } else {
                                dispatch(editOperation(values, setSubmitting, history, handleClose, styleId));
                            }
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            setFieldValue,
                        }) => (
                            <Form>
                                <AutoComplete
                                    onBlur={handleBlur}
                                    values={values.operationCodeId}
                                    onInputChange={(event: any) => {
                                        if (event !== null) {
                                            // Do Nothing
                                        }
                                    }}
                                    onChange={(event: any, value: any) => {
                                        if (value !== null) {
                                            const index = operationCodeData.findIndex((x: any) => x.id === value.id);
                                            const operation = operationCodeData.find((x: any) => x.id === value.id);
                                            handleChange(event);
                                            if (index >= 0) {
                                                setFieldValue('operationCodeId', value.id);
                                                setFieldValue('operationcode', operationCodeData[index].code);
                                                setFieldValue('smv', operationCodeData[index].smv);
                                                setFieldValue('tct', operationCodeData[index].tct);
                                                setFieldValue('description', operationCodeData[index].desc1);
                                                setFieldValue('operation', operation);
                                                setFieldValue('images', [
                                                    operation.machineAttachmentImage1,
                                                    operation.machineAttachmentImage2,
                                                    operation.machineAttachmentImage3,
                                                ]);
                                                setFieldValue('imageCodes', [
                                                    operation?.machineAttachment1Data?.displayName,
                                                    operation?.machineAttachment2Data?.displayName,
                                                    operation?.machineAttachment3Data?.displayName,
                                                ]);
                                            }
                                        }
                                    }}
                                    helperText={touched.operationCodeId && errors.operationCodeId}
                                    error={Boolean(touched.operationCodeId && errors.operationCodeId)}
                                    name={'operation'}
                                    label={t('Operation')}
                                    touched={touched.operationCodeId}
                                    options={operationCodeData}
                                    getOptionLabel={(option: any) => option.displayName}
                                    isRequired={true}
                                    defaultValue={() => {
                                        const index = operationCodeData.findIndex(
                                            (x: any) => x.id === values.operationCodeId,
                                        );
                                        return operationCodeData[index];
                                    }}
                                />

                                <div className={classes.populateField}>
                                    <div>{t('DESCRIPTION')}</div>
                                    <div>{values.description === '' ? '-' : values.description}</div>
                                </div>

                                <div className={classes.populateField}>
                                    <div>{t('SMV')}</div>
                                    <div>{values.smv === '' ? '-' : values.smv}</div>
                                </div>
                                <div className={classes.populateField}>
                                    <div>{t('Target Cycle Time (mm:ss.ms)')}</div>
                                    <div>{values.tct === 0 ? '-' : minuteToTime(values.tct)}</div>
                                </div>
                                <div className={classes.populateField}>
                                    <div>{t('SkillTypeName')}</div>
                                    <div>
                                        {values.operation.skillTypeName === '' ? '-' : values.operation.skillTypeName}
                                    </div>
                                </div>
                                <div className={classes.populateField}>
                                    <div>{t('SkillTypeCode')}</div>
                                    <div>
                                        {values.operation?.skillTypeData?.skillTypeCode === ''
                                            ? '-'
                                            : values.operation?.skillTypeData?.skillTypeCode}
                                    </div>
                                </div>
                                <SelectPicker
                                    id={values.machine}
                                    onBlur={handleBlur}
                                    values={values.machine}
                                    onChange={(event: any) => {
                                        const value = event.target.value;
                                        const index = machines.findIndex((x: any) => x.id === value);
                                        setFieldValue('machine', value);
                                        setFieldValue('machineName', machines[index].subType);
                                    }}
                                    helperText={touched.machine && errors.machine}
                                    error={Boolean(touched.machine && errors.machine)}
                                    name={'mc'}
                                    label={'M/C'}
                                    isRequired={true}
                                    touched={touched.machine}
                                    errors={errors.machine}
                                    data={machineSubtypeListing()}
                                />

                                <SelectPicker
                                    id={values.needleType}
                                    onBlur={handleBlur}
                                    values={values.needleType}
                                    onChange={(event: any) => {
                                        const value = event.target.value;
                                        const index = needlesTypes.findIndex((x: any) => x.id === value);
                                        setFieldValue('needleType', value);
                                        setFieldValue('needleTypeName', needlesTypes[index].needleType);
                                    }}
                                    helperText={touched.needleType && errors.needleType}
                                    error={Boolean(touched.needleType && errors.needleType)}
                                    name={'needleType'}
                                    label={t('NEEDLETYPE')}
                                    isRequired={true}
                                    touched={touched.needleType}
                                    errors={errors.needleType}
                                    data={needlesListing()}
                                />
                                <div className={classes.populateFieldAttachment}>
                                    <div>{t('Attachment')}</div>
                                    {values.images.length > 0 ? (
                                        <div className={classes.imgContainer}>
                                            {values.images.map((imgLink, idx) => {
                                                if (imgLink !== null) {
                                                    return (
                                                        <div
                                                            className={classes.innerImgContainer}
                                                            onClick={() => handleImageOpen(idx)}
                                                            key={idx}
                                                        >
                                                            <img
                                                                alt={t('Attachment')}
                                                                src={Utils.CommonFunctions.getImage(imgLink)}
                                                                className={classes.attachmentImage}
                                                            />
                                                            <Typography>{values.imageCodes[idx]}</Typography>
                                                        </div>
                                                    );
                                                } else {
                                                    return;
                                                }
                                            })}
                                        </div>
                                    ) : (
                                        <div>{'-'}</div>
                                    )}
                                </div>

                                <div className={classes.saveContainer}>
                                    <Button
                                        variant="outlined"
                                        size="large"
                                        className={classes.cancelButton}
                                        onClick={handleClose}
                                    >
                                        {t('CANCEL')}
                                    </Button>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        className={classes.saveButton}
                                    >
                                        {isSubmitting ? `${t('Saving')}...` : t('Save')}
                                    </Button>
                                </div>
                                <SimpleModal
                                    isOpen={openImage}
                                    body={
                                        <ImageCaurosel
                                            handleClose={handleImageClose}
                                            items={values.images.filter((val) => {
                                                return val !== null;
                                            })}
                                            imgToOpen={imgToOpen}
                                            alt={t('Attachment')}
                                        />
                                    }
                                />
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
}
